<template>
  <v-dialog
      v-model="show"
      eager
      persistent
      scrollable
      width="unset"
  >
    <v-card
        elevation="0"
        ref="dialog"
        :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile}"
    >
      <v-card-title class="headline">
        Движение закупки
      </v-card-title>
      <v-card-text>
        <v-timeline
            align-top
            dense
        >
          <div
              v-for="(status, index) in statuses"
              :key="status.id"
          >
            <v-timeline-item
                v-if="status.id !== 'draft'"
                :color="(index <= buyoutStatusIdx) ? status.color : 'grey'"
            >
              <template v-slot:icon>
                <v-avatar>
                  <v-icon
                      class="white--text"
                  >
                    {{status.icon}}
                  </v-icon>
                </v-avatar>
              </template>
              <div>
                <div class="font-weight-normal">
                  <strong>{{ status.title }}</strong>
                  <BuyoutDate
                      class="mb-1"
                      :dates="buyout && buyout.dates"
                      :status="status.id"
                  ></BuyoutDate>
                </div>
                <div>{{ status.description }}</div>
              </div>
            </v-timeline-item>
          </div>
        </v-timeline>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="$emit('close')"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BuyoutDate from '@/components/BuyoutDate'
import {fillDialogPosition} from '../services/utils';
import Statuses from '@/services/statuses';

export default {
  name: 'DialogShowBuyoutStatusHistory',
  components: {BuyoutDate},
  computed: {
    buyoutStatusIdx: function () {
      return this.buyout ? this.statuses.map(item => item.id).indexOf(this.buyout.status) : 0
    }
  },
  data () {
    return {
      show: false,
      statuses: null,
    }
  },
  props: {
    buyout: {
      type: Object
    },
    event: {
      type: PointerEvent
    },
    sourceStatuses: {
      type: Object
    }
  },
  methods: {
    filterStatuses() {
      this.statuses = Statuses.data?.filter(item => this.sourceStatuses.sourceStatuses?.includes(item.id))
      this.break = true;
    }
  },
  updated () {
    if(this.sourceStatuses && !this.break) {
      this.filterStatuses()
    }
  },
  watch: {
    event (val) {
      if (val) {
        this.show = true
        this.break = false;
        fillDialogPosition(val.target, this.$refs.dialog.$el.parentElement)
      } else {
        this.show = false;
      }
    }
  }
}
</script>

<style scoped>

</style>